import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form } from 'antd';
import { get } from 'lodash';

import dataFetcher from 'Parts/chore/dataFetcher';
import { fetchPurchasedTicket, updatePurchasedTicket, fetchEvent } from '../../eventActions';

import EventAdminAttendeesTicketForm from './EventAdminAttendeesTicketForm';

const mapStateToProps = state => ({
  campaignId: get(state, 'campaign.campaign.id'),
  ticket: get(state, 'Event.purchasedTicket', {}),
  eventSettings: get(state, 'Event.event.settings'),
  locale: get(state, 'session.language'),
  isUpdatePurchasedTicketInProgress: get(state, 'Event.isUpdatePurchasedTicketInProgress')
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchPurchasedTicket,
    updatePurchasedTicket,
    fetchEvent
}, dispatch);

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    dataFetcher,
    Form.create()
)(EventAdminAttendeesTicketForm);
